import { render, staticRenderFns } from "./IconColour.vue?vue&type=template&id=5bde3ddc&scoped=true&"
import script from "./IconColour.vue?vue&type=script&lang=ts&"
export * from "./IconColour.vue?vue&type=script&lang=ts&"
import style0 from "./IconColour.vue?vue&type=style&index=0&id=5bde3ddc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bde3ddc",
  null
  
)

export default component.exports